module.exports = __webpack_public_path__ + "static/media/gacha-ticket6487de007232eefa65051d3a66397db6.webp";